import {
  ISFAHAN_CITY,
  MASHHAD_CITY,
  SHIRAZ_CITY,
  SUBWAY_ISFAHAN_LIGHT_IMAGE,
  SUBWAY_ISFAHAN_NIGHT_IMAGE,
  SUBWAY_MASHHAD_LIGHT_IMAGE,
  SUBWAY_MASHHAD_NIGHT_IMAGE,
  SUBWAY_SHIRAZ_LIGHT_IMAGE,
  SUBWAY_SHIRAZ_NIGHT_IMAGE,
  SUBWAY_TABRIZ_LIGHT_IMAGE,
  SUBWAY_TABRIZ_NIGHT_IMAGE,
  SUBWAY_TEHRAN_LIGHT_IMAGE,
  SUBWAY_TEHRAN_NIGHT_IMAGE,
  TABRIZ_CITY,
  TEHRAN_CITY
} from './CONSTANTS';

export function getNightImageUrl(chooseCity: string) {
  let url = '';
  switch (chooseCity) {
    case TEHRAN_CITY:
      url = SUBWAY_TEHRAN_NIGHT_IMAGE;
      break;
    case TABRIZ_CITY:
      url = SUBWAY_TABRIZ_NIGHT_IMAGE;
      break;
    case SHIRAZ_CITY:
      url = SUBWAY_SHIRAZ_NIGHT_IMAGE;
      break;
    case ISFAHAN_CITY:
      url = SUBWAY_ISFAHAN_NIGHT_IMAGE;
      break;
    case MASHHAD_CITY:
      url = SUBWAY_MASHHAD_NIGHT_IMAGE;
      break;
  }
  return url;
}

export function getLightImageUrl(chooseCity: string) {
  let url = '';
  switch (chooseCity) {
    case TEHRAN_CITY:
      url = SUBWAY_TEHRAN_LIGHT_IMAGE;
      break;
    case TABRIZ_CITY:
      url = SUBWAY_TABRIZ_LIGHT_IMAGE;
      break;
    case SHIRAZ_CITY:
      url = SUBWAY_SHIRAZ_LIGHT_IMAGE;
      break;
    case ISFAHAN_CITY:
      url = SUBWAY_ISFAHAN_LIGHT_IMAGE;
      break;
    case MASHHAD_CITY:
      url = SUBWAY_MASHHAD_LIGHT_IMAGE;
      break;
  }
  return url;
}
